import { useSelector } from 'react-redux';

/**
 * Hook for accessing the current participant role and checking role membership.
 */
const useActiveRole = () => {
  const { activeRole, availableRoles, loading } = useSelector((state) => state.roles);

  const isRole = (type) => activeRole === type;
  const hasRole = (type) => availableRoles.includes(type);

  return { activeRole, availableRoles, isRole, hasRole, loading };
};

export default useActiveRole;
